

















import { Component, Vue, Prop } from 'vue-property-decorator'
import Tab from '@/components/Tabs/Tab.vue'
import { TabData } from '@/components/Tabs/TabTypes'

@Component({
  components: {
    Tab
  }
})
export default class Tabs extends Vue {
  @Prop({ required: false, default: false }) inline!: boolean // determines if tabs are inline or a header
  @Prop({ required: false }) tabData!: TabData[]

  selectedIndex = 0 // the index of the selected tab

  updateSelectedTab (i: number, tabTitle: string) {
    this.selectedIndex = i
    this.$emit('input', tabTitle)
  }
}
